var exports = {
  "AB": "mergedIcon__Pg7O9-",
  "kX": "closedIcon__m_PuPp",
  "LR": "draftIcon__0QjIXF",
  "kl": "openIcon__iCMMiR",
  "Vd": "hovercardLink__4ZoPq8",
  "lT": "countText__K1BckZ",
  "dW": "pullRequestItemContent__RhjHb1",
  "p4": "repositoryInfo__eCqFuw",
};

module.exports = exports;
